import React, { useEffect, useState, Co } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  Truck as TruckIcon,
  Grid as GridIcon,
  Users as UsersIcon,
  Sliders as SlidersIcon,
  File as FileIcon,
  DollarSign,
  CreditCard,
  Settings,
} from 'react-feather';
import dayjs from 'dayjs';
import { HomeNavbar } from '../components/Navbars';
import { MainFooter } from '../components/Footers';
import * as actions from '../redux/actions';
import { Loading } from '../components/Loading';
import GoldPriceForm from '../components/Forms/Gold/GoldPriceForm';
import accessRight from '../utils/functions/accessRight';
import { Store } from '@mui/icons-material';

export default function Home() {
  const dispatch = useDispatch();
  const me = useSelector((state) => state.me);
  const information = useSelector((state) => state.information);

  useEffect(() => {
    dispatch(actions.meGet());
    dispatch(actions.informationAll());
    return () => {};
  }, []);

  if (!me.userData) {
    return <Loading />;
  }
  return (
    <div className="min-h-screen">
      <HomeNavbar onMobileNavOpen={() => {}} />
      <div className="min-h-screen ">
        <div className="md:flex py-40 lg:p-40 container pt-30 mr-auto ml-auto w-full ">
          <div className="border-r-4 border-slate-300  md:flex hidden md:bolck    xl:w-2/3 h-full  justify-center ">
            <GoldPriceForm />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 w-full h-full ">
            {accessRight(me, 'GOLD') && (
              <Link to={'/gold'}>
                <div className="m-4">
                  <div className="  bg-sky-500 shadow rounded text-center  py-8 px-4 lg: h-40  transition-transform transform hover:scale-105">
                    <div className="flex justify-center">
                      {/* {actions.informationAll?.information?.image_logo} */}
                      <Store className="text-white" style={{ fontSize: 50 }} />
                    </div>

                    <p className=" text-white mt-4">ซื้อ-ขาย </p>
                  </div>
                </div>
              </Link>
            )}
            {accessRight(me, 'MATERIAL') && (
              <div className="m-4">
                <Link to={'/material'}>
                  <div className="bg-indigo-600  shadow rounded text-center  py-8 px-4 lg:h-40  transition-transform transform hover:scale-105">
                    <div className="flex justify-center">
                      <i className="fa-solid fa-toolbox text-white text-4xl my-2"></i>
                    </div>

                    <p className=" text-white mt-4">คลังทอง</p>
                  </div>
                </Link>
              </div>
            )}
            {accessRight(me, 'ACCOUNTING') && (
              <div className="m-4">
                <Link to={'/accounting'}>
                  <div className="bg-pink-500  shadow rounded text-center  py-8 px-4 lg:h-40  transition-transform transform hover:scale-105">
                    <div className="flex justify-center">
                      <CreditCard size={50} color="white" />
                    </div>
                    <p className=" text-white mt-4">การบัญชี</p>
                  </div>
                </Link>
              </div>
            )}
            {accessRight(me, 'INFORMATION') && (
              <div className="p-4">
                <Link to={'/information'}>
                  <div className="bg-gray-500 shadow rounded text-center  py-8 px-4 lg:h-40  transition-transform transform hover:scale-105">
                    <div className="flex justify-center">
                      {/* {actions.informationAll?.information?.image_logo} */}
                      <SlidersIcon size={50} color="white" />
                    </div>
                    <p className=" text-white mt-4">การตั้งค่า</p>
                  </div>
                </Link>
              </div>
            )}
            {accessRight(me, 'USER') && (
              <div className="p-4">
                <Link to={'/user/material-type'}>
                  <div className="bg-red-500  shadow rounded text-center  py-8 px-4 lg:h-40  transition-transform transform hover:scale-105">
                    <div className="flex justify-center">
                      <Settings size={50} color="white" />
                    </div>

                    <p className=" text-white mt-4">ผู้ดูแลระบบ</p>
                  </div>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
      <div>
        <MainFooter />
      </div>
    </div>
  );
}
